import { render, staticRenderFns } from "./IndexDocumentUserModal.vue?vue&type=template&id=8754162c&"
import script from "./IndexDocumentUserModal.vue?vue&type=script&lang=js&"
export * from "./IndexDocumentUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports